import $ from "jquery";
import { ImajizeFileReader } from "./file_reader.js";

$(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $("meta[name='csrf-token']").attr("content")
        }
    });
});


class Uploader {

    constructor(root) {

        this.root = root

        this.fileInputs = this.root.querySelectorAll('input[type=file]')
        this.submitButton = this.root.querySelector('.upload-button')
        this.resetButton = this.root.querySelector('.reset-button')
        this.form = this.root.querySelector('form')

        this.acceptedImageTypes = /(jpe?g|png)$/i;
        this.acceptedVideoTypes = /(mpe?g|mp4|webm|msvideo|avi|video\/quicktime)$/i;

        this.submitted = false

        let that = this

        for (let fileInput of this.fileInputs) {
            fileInput.onchange = (e) => {
                that.handleFiles(e.target, e.target.files)
            }

            fileInput.ondrop = (e) => {
                that.handleItems(e.target, e.dataTransfer.items)
            }
        }

        this.submitButton.onclick = () => {
            that.submit()
        }

        if (this.resetButton !== null) {
            this.resetButton.onclick = () => {
                that.reset()
            }
        }

        this.root.ondragenter = (e) => {
            e.preventDefault();
            if (!window.mappingDragActive) {
                that.root.classList.add('drag-over')
            }
        }

        this.root.ondragover = (e) => {
            e.preventDefault();
            if (!window.mappingDragActive) {
                that.root.classList.add('drag-over')
            }
        }

        this.root.ondragleave = (e) => {
            e.preventDefault();
            if (!window.mappingDragActive) {
                that.root.classList.remove('drag-over')
            }
        }

        this.root.ondrop = (e) => {
            e.preventDefault();
            if (!window.mappingDragActive) {
                that.root.classList.remove('drag-over')

                const items = e.dataTransfer && e.dataTransfer.items
                if (items && items.length > 0 && that.fileInputs.length > 0) {
                    that.handleItems(that.fileInputs[0], items)
                }
            }

        }
    }

    /**
     * Default implementation of row validation for normal and multirow upload
     *
     * @param target {HTMLElement}
     * @param files {Array}
     */
    validateRow(target, files) {
        throw new Error("not implemented")
    }

    reset() {
        throw new Error("not implemented")
    }

    async handleItems(target, itemList) {
        let fileReader = new ImajizeFileReader()
        let files = await fileReader.getAllFileEntries(itemList)

        // filter out files where name starting with a dot
        files = files.filter((file) => !file.name.startsWith('.'))

        if (files.length === 0) {
            return
        }

        this.validateRow(target, files)
    }


    handleFiles(target, fileList) {
        let files = [...fileList]
        // filter out files where name starting with a dot
        files = files.filter((file) => !file.name.startsWith('.'))

        if (files.length === 0) {
            return
        }

        for (let file of files) {
            //  set fullPath to be in sync with drag and drop
            file.fullPath = file.webkitRelativePath
        }

        this.validateRow(target, files)
    }

    /**

     * @param data
     */
    postVariant(data) {
        let variantUUUID = this.form.getAttribute('data-variant')

        if (variantUUUID) {
            // check for re-upload first
            return {
                uuid: variantUUUID
            }
        } else if (data) {
            // check if data was parameter
            const variantData = {
                project_id: this.form.getAttribute('data-project'),
                product_name: data['product_name'],
                manufacturer_name: data['manufacturer_name'],
                sku: data['sku'],
                year: data['year']
            }
            return this._postVariant(variantData)
        } else {
            // get data from form
            const data = {
                project_id: this.form.getAttribute('data-project'),
                product_name: this.form.querySelector('.product_name').value,
                manufacturer_name: this.form.querySelector(".manufacturer_name").value,
                sku: this.form.querySelector(".sku").value,
                year: this.form.querySelector(".year").value
            }

            return this._postVariant(data)
        }
    }

    _postVariant(variant) {
        let request = {
            url: this.form.getAttribute('action'),
            type: "POST",
            async: false,
            data: {
                variant: variant
            }
        }

        try {
            let result = $.ajax(request)
            const json = result.responseJSON
            if (!json) return undefined
            // Server returns { variant: { uuid: "..." } }; normalize to the variant object for S3Upload
            return json.variant != null ? json.variant : json
        } catch (error) {
            console.log("Error posting variant")
            console.log(error)
            return undefined
        }
    }

    statusError(elem, text) {
        elem.style.color = 'red'
        elem.innerHTML = text
    }

    statusSuccess(elem, text) {
        elem.style.color = 'green'
        elem.innerHTML = text
    }

    submit() {
        if (this.submitted) {
            return
        }
        this.submitted = true

        this.submitButton.style.background = 'rgba(0,123,255,0.5)'
        this.submitButton.innerHTML = `Uploading (0%)`

        this.doSubmit()
    }

    doSubmit() {
        throw new Error("not implemented")
    }


    // event handler methods for S3Upload
    uploadProgress(total) {
        let c1 = 'rgba(0, 123, 255, 1)'
        let c2 = 'rgba(0, 123, 255, .3)'
        let p = total

        this.submitButton.style.background = `linear-gradient(90deg, ${c1} 0%, ${c1} ${p}%, ${c2} ${p}%, ${c2} 100%)`
        this.submitButton.innerHTML = `Uploading (${p}%)`
    }

    uploadComplete() {
        console.log("upload complete")
        this.submitButton.innerHTML = `Upload complete`
        this.submitButton.style.background = '#218838'
        this.submitButton.innerText = 'Upload complete'
        let that = this
        window.setTimeout(() => {
            window.location = that.form.getAttribute('data-redirect')
        }, 1000)

    }

    uploadFailed(message = 'Upload failed. Please try again.') {
        console.warn("[Upload] Upload failed (create product or upload request failed)")
        this.submitButton.style.background = 'red'
        this.submitButton.innerText = 'Upload failed'
        this.showUploadToast(message)
        let that = this
        window.setTimeout(() => {
            window.location = that.form.getAttribute('data-redirect')
        }, 1000)
    }

    /**
     * Show a Bootstrap toast for upload feedback (failure or info).
     * @param {string} message
     * @param {string} [type] - 'danger' (default for failures), 'info', etc.
     */
    showUploadToast(message, type = 'danger') {
        const container = document.getElementById('toasts') || document.body
        const toast = document.createElement('div')
        toast.className = `toast align-items-center text-white border-0 ${type === 'danger' ? 'bg-danger' : 'bg-dark'}`
        toast.setAttribute('role', 'status')
        toast.setAttribute('aria-live', 'polite')
        toast.setAttribute('aria-atomic', 'true')
        toast.setAttribute('data-bs-autohide', 'true')
        toast.setAttribute('data-bs-delay', '8000')
        toast.style.minWidth = '20em'
        toast.style.marginBottom = '0.5em'
        toast.innerHTML = `
            <div class="d-flex">
                <div class="toast-body">${message}</div>
                <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
        `
        container.appendChild(toast)
        try {
            const instance = new bootstrap.Toast(toast)
            toast.addEventListener('hidden.bs.toast', () => {
                instance.dispose()
                toast.remove()
            }, { once: true })
            instance.show()
        } catch (e) {
            setTimeout(() => toast.remove(), 8000)
        }
    }

    validateVideo() {
        const url = this.video.value
        const result_container = this.root.querySelector('#normal_reupload_video_result')
        const images = result_container.querySelectorAll('img')
        const videoThumbnail = result_container.querySelector('.video-thumbnail')
        const videoChecking = result_container.querySelector('span.video-checking')
        const videoError = result_container.querySelector('span.video-error')


        if (url === "") {
            for (let img of images) {
                img.style.display = 'none'
            }

            videoChecking.style.display = 'none'
            videoError.style.display = 'none'
            return
        }

        // Stop if the value has not changed
        if (url === this.videoUrl) {
            return
        }

        this.videoUrl = url

        if (this.videoTimeout) {
            window.clearTimeout(this.videoTimeout);
        }

        this.videoTimeout = window.setTimeout(function () {
            for (let img of images) {
                img.style.display = 'none'
            }

            videoChecking.style.display = 'inline'
            videoError.style.display = 'none'

            $.getJSON(`/products/oembed?url=${encodeURI(url)}`, data => {
                // Only continue if the checked URL is still the same as initially entered
                if (encodeURI(url) === data.url) {

                    videoChecking.style.display = 'none'

                    if (data.result) {
                        result_container.querySelector(`img.${data.result.provider.toLowerCase()}`).style.display = 'inline'
                        videoThumbnail.setAttribute('src', data.result.thumbnail)
                        videoThumbnail.style.display = 'inline'
                    } else {
                        videoError.style.display = 'inline'
                    }
                }
            });
        }, 500);
    }

    isImage(file) {
        const suffix = file.name.toLowerCase().split('.').pop()
        return (this.acceptedImageTypes.test(file.type) || this.acceptedImageTypes.test(suffix))
    }

    isVideo(file) {
        const suffix = file.name.toLowerCase().split('.').pop()
        return (this.acceptedVideoTypes.test(file.type) || this.acceptedVideoTypes.test(suffix))
    }

    isImageOrVideo(file) {
        return (this.isImage(file) || this.isVideo(file))
    }

    makeSortable(element, onUpdate) {
        const items = element.querySelectorAll('li');

        // Create dash elements for drag and drop
        this.createDashElements(element);

        items.forEach(item => {
            item.draggable = true;

            item.addEventListener('dragstart', (e) => {
                window.mappingDragActive = true;
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/html', item.outerHTML);
                item.classList.add('dragging');

                // Add visual feedback immediately without transitions
                item.style.transition = 'none';
                item.style.opacity = '0.3';
                item.style.transform = 'rotate(5deg)';

                // Create a custom drag image that appears at the cursor
                const dragImage = item.cloneNode(true);
                dragImage.style.position = 'absolute';
                dragImage.style.top = '-1000px';
                dragImage.style.left = '-1000px';
                dragImage.style.opacity = '0.8';
                dragImage.style.transform = 'rotate(5deg)';
                dragImage.style.pointerEvents = 'none';
                document.body.appendChild(dragImage);

                // Set the drag image to appear at the cursor center
                const rect = dragImage.getBoundingClientRect();
                e.dataTransfer.setDragImage(dragImage, rect.width / 2, rect.height / 2);

                // Clean up the temporary element after drag starts
                setTimeout(() => {
                    if (document.body.contains(dragImage)) {
                        document.body.removeChild(dragImage);
                    }
                }, 0);

                // Prevent upload area highlighting
                const parentContainer = element.closest('#normal_upload, #multirow_upload, #video_upload, #folder_upload, #normal_reupload, #multirow_reupload, #gallery_upload, #gallery_reupload');
                if (parentContainer) {
                    parentContainer.classList.add('dragging-mapping');
                }
            });

            item.addEventListener('dragend', () => {
                window.mappingDragActive = false;
                item.classList.remove('dragging');
                item.style.transition = '';
                item.style.opacity = '';
                item.style.transform = '';

                // Re-enable upload area
                const parentContainer = element.closest('#normal_upload, #multirow_upload, #video_upload, #folder_upload, #normal_reupload, #multirow_reupload, #gallery_upload, #gallery_reupload');
                if (parentContainer) {
                    parentContainer.classList.remove('dragging-mapping');
                }
            });
        });

        // Add drag events to the container for dash highlighting
        element.addEventListener('dragover', (e) => {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';

            const draggingItem = element.querySelector('.dragging');
            if (!draggingItem) return;

            // Reset all dash highlighting
            element.querySelectorAll('.dash-element').forEach(dash => {
                dash.classList.remove('drop-target');
            });

            // Find which dash we're hovering over
            const targetDash = this.findDashAtPosition(element, e.clientX);
            if (targetDash) {
                targetDash.classList.add('drop-target');
            }
        });

        element.addEventListener('drop', (e) => {
            e.preventDefault();

            const draggingItem = element.querySelector('.dragging');
            if (!draggingItem) return;

            // Find which dash is highlighted
            const targetDash = element.querySelector('.dash-element.drop-target');

            // Reset all dash highlighting
            element.querySelectorAll('.dash-element').forEach(dash => {
                dash.classList.remove('drop-target');
            });

            if (!targetDash) return;

            // Get the target position from the dash
            const targetIndex = parseInt(targetDash.getAttribute('data-position'));
            const allElements = [...element.querySelectorAll('li')];
            const draggingIndex = allElements.indexOf(draggingItem);

            // Only move if positions are different
            if (draggingIndex !== targetIndex) {
                // Remove the dragging item
                draggingItem.remove();

                // Insert at the target position
                const remainingElements = element.querySelectorAll('li');

                // If moving rightward (targetIndex > draggingIndex), we need to adjust for the removed item
                const adjustedTargetIndex = draggingIndex < targetIndex ? targetIndex - 1 : targetIndex;

                if (adjustedTargetIndex < remainingElements.length) {
                    element.insertBefore(draggingItem, remainingElements[adjustedTargetIndex]);
                } else {
                    element.appendChild(draggingItem);
                }

                // Update dash positions after moving
                this.updateDashPositions(element);
            }

            if (onUpdate) onUpdate();
        });
    }

    createDashElements(element) {
        // Remove any existing dash elements
        element.querySelectorAll('.dash-element').forEach(dash => dash.remove());

        const items = element.querySelectorAll('li');

        // Create dash elements between items
        for (let i = 0; i <= items.length; i++) {
            const dash = document.createElement('div');
            dash.className = 'dash-element';
            dash.setAttribute('data-position', i);
            dash.style.cssText = `
                display: inline-block;
                width: 6px;
                height: 6px;
                background-color: #c7d2fe;
                border-radius: 50%;
                margin: 0 0.25em 0 0;
                vertical-align: bottom;
                cursor: pointer;
                transition: all 0.05s ease;
            `;

            if (i === 0) {
                // Insert before first item
                element.insertBefore(dash, items[0]);
                dash.style.opacity = '0';
            } else if (i === items.length) {
                // Insert after last item
                element.appendChild(dash);
                dash.style.opacity = '0';
            } else {
                // Insert between items
                element.insertBefore(dash, items[i]);
            }
        }
    }

    updateDashPositions(element) {
        // Remove all existing dashes and recreate them
        this.createDashElements(element);
    }

    findDashAtPosition(element, x) {
        const dashes = element.querySelectorAll('.dash-element');
        const draggingItem = element.querySelector('.dragging');

        for (let dash of dashes) {
            const box = dash.getBoundingClientRect();

            // Check if cursor is within the bounds of this dash
            if (x >= box.left && x <= box.right) {
                return dash;
            }
        }

        // If cursor is not over any dash, find the closest one
        let closestDash = null;
        let closestDistance = Infinity;

        dashes.forEach(dash => {
            const box = dash.getBoundingClientRect();
            const dashCenterX = box.left + box.width / 2;
            const distance = Math.abs(x - dashCenterX);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestDash = dash;
            }
        });

        return closestDash;
    }
}

export { Uploader };